import { render, staticRenderFns } from "./modal-buttons.vue?vue&type=template&id=705dfecd&scoped=true"
import script from "./modal-buttons.vue?vue&type=script&lang=js"
export * from "./modal-buttons.vue?vue&type=script&lang=js"
import style0 from "./modal-buttons.vue?vue&type=style&index=0&id=705dfecd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705dfecd",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/components/modal-custom/modal-buttons.vue
// module id = null
// module chunks = 